<div
  *ngIf="isChatAvailable"
  class="chatbot"
  [class.chatbot--compact]="settings.compactDensity"
  [style.--chat-font-scale]="fontScale"
>
  <button
    *ngIf="!isOpen && !isDockedInAccountNav"
    class="chatbot__launcher"
    type="button"
    (click)="toggleOpen($event)"
    [attr.aria-expanded]="isOpen"
    aria-controls="chatbot-panel"
    [attr.aria-label]="
      conversationAttentionCount
        ? 'Abrir Inteligência Wosi, há conversas com novidades'
        : 'Abrir Inteligência Wosi'
    "
    [attr.title]="'Atalho: ' + chatOpenShortcutLabel"
  >
    <span
      *ngIf="conversationAttentionCount"
      class="chatbot__launcherBadge"
      [class.is-busy]="hasBackgroundBusy"
      [class.is-count]="conversationAttentionCount > 1"
      aria-hidden="true"
    >{{ conversationAttentionCount > 1 ? conversationAttentionBadge : '' }}</span>
    <span class="chatbot__launcherAvatar" aria-hidden="true">
      <img
        class="chatbot__brandMark"
        [src]="intelligenceMarkSrc"
        alt=""
        width="40"
        height="40"
      />
      <span class="chatbot__launcherStatus"></span>
    </span>

    <span class="chatbot__launcherCopy">
      <span class="chatbot__launcherTitle">Inteligência Wosi</span>
      <span class="chatbot__launcherHint">IA generativa</span>
    </span>
  </button>

  <div
    *ngIf="isOpen && !isMobile"
    class="chatbot__backdrop"
    [class.chatbot__backdrop--clear]="!isExpanded"
    aria-hidden="true"
    (click)="onBackdropClick($event)"
  ></div>

  <section
    *ngIf="isOpen"
    #chatPanel
    id="chatbot-panel"
    class="chatbot__panel"
    [class.chatbot__panel--expanded]="isExpanded && !isMobile"
    [class.chatbot__panel--sidebar-open]="showSidebar"
    [class.chatbot__panel--mobile-fullscreen]="isMobile"
    [class.chatbot__panel--dragging]="isDragging"
    [class.chatbot__panel--resizing]="isResizing"
    [class.chatbot__panel--resizing-sidebar]="isResizingSidebar"
    [style.--chat-sidebar-width.px]="sidebarWidth"
    [ngStyle]="panelStyle"
    role="dialog"
    [attr.aria-modal]="isExpanded || isMobile"
    aria-label="Inteligência Wosi"
  >
    <header class="chatbot__header">
      <div class="chatbot__brand">
        <button
          class="chatbot__sidebarToggle"
          type="button"
          (click)="toggleSidebar($event)"
          [class.is-active]="showSidebar"
          [attr.aria-label]="sidebarToggleLabel"
          [attr.aria-pressed]="showSidebar"
        >
          <span class="material-symbols-outlined" aria-hidden="true">forum</span>
          <span
            *ngIf="conversationAttentionCount"
            class="chatbot__headerBadge"
            [class.is-busy]="hasBackgroundBusy"
            [class.is-count]="conversationAttentionCount > 1"
            aria-hidden="true"
          >{{ conversationAttentionCount > 1 ? conversationAttentionBadge : '' }}</span>
        </button>

        <span class="chatbot__brandDivider" aria-hidden="true"></span>

        <div
          class="chatbot__dragZone"
          [class.chatbot__dragZone--active]="!isMobile && !isExpanded"
          (pointerdown)="onDragHandlePointerDown($event)"
          (pointermove)="onDragHandlePointerMove($event)"
          (pointerup)="onDragHandlePointerUp($event)"
          (pointercancel)="onDragHandlePointerUp($event)"
        >
          <div class="chatbot__avatar" aria-hidden="true">
            <img
              class="chatbot__brandMark"
              [src]="intelligenceMarkSrc"
              alt=""
              width="40"
              height="40"
            />
            <span class="chatbot__avatarStatus"></span>
          </div>

          <div class="chatbot__titles">
            <div class="chatbot__name">{{ activeConversationTitle }}</div>
            <div class="chatbot__status">
              <span class="chatbot__statusDot" aria-hidden="true"></span>
              <span class="chatbot__statusLabel">Inteligência Wosi · IA generativa</span>
            </div>
          </div>

          <span
            *ngIf="!isMobile && !isExpanded"
            class="material-symbols-outlined chatbot__dragHandle"
            aria-hidden="true"
          >drag_indicator</span>
        </div>
      </div>

      <div class="chatbot__headerActions">
        <div #headerMore class="chatbot__more" [class.chatbot__more--open]="headerMenuOpen">
          <button
            class="chatbot__headerBtn"
            type="button"
            (click)="toggleHeaderMenu($event)"
            [class.is-active]="headerMenuOpen"
            [attr.aria-expanded]="headerMenuOpen"
            aria-haspopup="menu"
            aria-label="Mais ações do chat"
          >
            <span class="material-symbols-outlined" aria-hidden="true">more_vert</span>
          </button>

          <div
            *ngIf="headerMenuOpen"
            class="chatbot__moreMenu"
            role="menu"
            aria-label="Ações do assistente"
          >
            <button
              class="chatbot__moreItem"
              type="button"
              role="menuitem"
              (click)="startNewConversation($event)"
            >
              <span class="material-symbols-outlined" aria-hidden="true">edit_square</span>
              Nova conversa
            </button>
            <button
              *ngIf="!isMobile"
              class="chatbot__moreItem"
              type="button"
              role="menuitem"
              (click)="toggleExpanded($event)"
            >
              <span class="material-symbols-outlined" aria-hidden="true">
                {{ isExpanded ? 'close_fullscreen' : 'open_in_full' }}
              </span>
              {{ isExpanded ? 'Restaurar tamanho' : 'Expandir chat' }}
            </button>
            <span class="chatbot__moreSep" aria-hidden="true"></span>
            <button
              class="chatbot__moreItem"
              type="button"
              role="menuitem"
              (click)="exportActiveConversation('md', $event)"
            >
              <span class="material-symbols-outlined" aria-hidden="true">download</span>
              Exportar Markdown
            </button>
            <button
              class="chatbot__moreItem"
              type="button"
              role="menuitem"
              (click)="exportActiveConversation('json', $event)"
            >
              <span class="material-symbols-outlined" aria-hidden="true">data_object</span>
              Exportar JSON
            </button>
            <button
              *ngIf="canUseAgentCommands"
              class="chatbot__moreItem"
              type="button"
              role="menuitem"
              (click)="shareActiveConversation($event)"
            >
              <span class="material-symbols-outlined" aria-hidden="true">share</span>
              Compartilhar com admin
            </button>
            <span
              *ngIf="canUseAgentCommands"
              class="chatbot__moreSep"
              aria-hidden="true"
            ></span>
            <button
              *ngIf="canUseAgentCommands"
              class="chatbot__moreItem"
              type="button"
              role="menuitem"
              (click)="openSettings($event)"
            >
              <span class="material-symbols-outlined" aria-hidden="true">settings</span>
              Configurações
            </button>
          </div>
        </div>
        <button
          class="chatbot__headerBtn"
          type="button"
          (click)="startNewConversation($event)"
          aria-label="Nova conversa"
        >
          <span class="material-symbols-outlined" aria-hidden="true">edit_square</span>
        </button>
        <button
          *ngIf="canUseAgentCommands"
          class="chatbot__headerBtn"
          type="button"
          (click)="toggleSettings($event)"
          [class.is-active]="settingsOpen"
          [attr.aria-pressed]="settingsOpen"
          aria-label="Configurações do chat"
        >
          <span class="material-symbols-outlined" aria-hidden="true">settings</span>
        </button>
        <button
          class="chatbot__headerBtn"
          type="button"
          (click)="close($event)"
          aria-label="Fechar chat"
        >
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      </div>
    </header>

    <div class="chatbot__body">
      <aside
        class="chatbot__sidebar"
        [class.chatbot__sidebar--open]="showSidebar"
        aria-label="Conversas salvas"
      >
        <div class="chatbot__sidebarHeader">
          <span class="chatbot__sidebarTitle">Conversas</span>
          <button
            class="chatbot__sidebarNewBtn"
            type="button"
            (click)="startNewConversation($event)"
          >
            <span class="material-symbols-outlined" aria-hidden="true">add</span>
            Nova
          </button>
        </div>

        <div class="chatbot__sidebarSearch">
          <span class="material-symbols-outlined chatbot__sidebarSearchIcon" aria-hidden="true">
            search
          </span>
          <input
            class="chatbot__sidebarSearchInput"
            type="search"
            [(ngModel)]="conversationSearchQuery"
            placeholder="Buscar por título ou conteúdo…"
            aria-label="Buscar conversas"
            autocomplete="off"
            spellcheck="false"
          />
          <button
            *ngIf="hasConversationSearch"
            type="button"
            class="chatbot__sidebarSearchClear"
            aria-label="Limpar busca"
            (click)="clearConversationSearch($event)"
          >
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        </div>

        <div class="chatbot__sidebarList" role="list">
          <button
            *ngFor="let conversation of filteredConversations"
            type="button"
            class="chatbot__conversationItem"
            [class.is-active]="conversation.id === activeConversationId"
            [class.is-unread]="isConversationUnread(conversation)"
            [class.is-busy]="isConversationBusy(conversation.id)"
            role="listitem"
            (click)="selectConversation(conversation.id, $event)"
          >
            <span
              *ngIf="isConversationUnread(conversation) || isConversationBusy(conversation.id)"
              class="chatbot__conversationDot"
              [class.is-busy]="isConversationBusy(conversation.id)"
              aria-hidden="true"
            ></span>
            <span class="chatbot__conversationMain">
              <span
                *ngIf="parentConversationTitle(conversation)"
                class="chatbot__conversationFrom"
              >De {{ parentConversationTitle(conversation) }}</span>
              <span class="chatbot__conversationTitle">{{ conversation.title }}</span>
              <span class="chatbot__conversationPreview">
                {{ conversationPreview(conversation) }}
              </span>
              <span class="chatbot__conversationMeta">
                {{ formatConversationDate(conversation.updatedAt) }}
                <ng-container *ngIf="conversation.messages.length">
                  · {{ conversation.messages.length }} msg
                </ng-container>
              </span>
            </span>
            <button
              type="button"
              class="chatbot__conversationDelete"
              aria-label="Excluir conversa"
              (click)="deleteConversation(conversation.id, $event)"
            >
              <span class="material-symbols-outlined" aria-hidden="true">delete</span>
            </button>
          </button>

          <p
            *ngIf="!sortedConversations.length"
            class="chatbot__sidebarEmpty"
          >
            Nenhuma conversa salva ainda.
          </p>
          <p
            *ngIf="sortedConversations.length && !filteredConversations.length"
            class="chatbot__sidebarEmpty"
          >
            Nenhuma conversa encontrada para “{{ conversationSearchQuery.trim() }}”.
          </p>
        </div>

        <span
          *ngIf="showSidebar && !isMobile && !isExpanded"
          class="chatbot__sidebarResize"
          (pointerdown)="onSidebarResizePointerDown($event)"
          (pointermove)="onSidebarResizePointerMove($event)"
          (pointerup)="onSidebarResizePointerUp($event)"
          (pointercancel)="onSidebarResizePointerUp($event)"
          aria-hidden="true"
        ></span>
      </aside>

      <div class="chatbot__main">
        <div class="chatbot__messagesWrap">
          <div
            class="chatbot__messages"
            #messagesViewport
            aria-live="polite"
            aria-relevant="additions"
            (scroll)="onMessagesScroll()"
            (wheel)="onMessagesWheel($event)"
            (pointerdown)="onMessagesPointerDown($event)"
            (pointermove)="onMessagesPointerMove($event)"
            (pointerup)="onMessagesPointerUp()"
            (pointercancel)="onMessagesPointerUp()"
          >
          <div
            *ngIf="messages.length === 0"
            class="chatbot__welcome"
            role="note"
            aria-label="Boas-vindas"
          >
            <div class="chatbot__welcomeHero">
              <div class="chatbot__welcomeAvatar" aria-hidden="true">
                <img
                  class="chatbot__brandMark"
                  [src]="intelligenceMarkSrc"
                  alt=""
                  width="42"
                  height="42"
                />
              </div>
              <div class="chatbot__welcomeIntro">
                <div class="chatbot__welcomeEyebrow">Inteligência Wosi</div>
                <div class="chatbot__welcomeTitle">{{ welcomeHeadline }}</div>
              </div>
            </div>

            <p class="chatbot__welcomeText">{{ welcomeMessage }}</p>
            <p class="chatbot__welcomeSub">{{ welcomeSubtitle }}</p>

            <div
              class="chatbot__quickSection"
              [attr.aria-busy]="quickQuestionsLoading"
            >
              <div class="chatbot__quickLabel">
                <span>Sugestões para começar</span>
                <span
                  *ngIf="quickQuestionsLoading"
                  class="chatbot__quickStatus"
                  aria-live="polite"
                >
                  <span
                    class="spinner-border spinner-border-sm text-primary"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Atualizando para esta tela…
                </span>
                <span
                  *ngIf="!quickQuestionsLoading && quickQuestionsGenerated"
                  class="chatbot__quickStatus chatbot__quickStatus--ready"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">check_circle</span>
                  Nesta tela
                </span>
              </div>

              <div
                *ngIf="quickQuestionsLoading"
                class="chatbot__quickGrid"
                role="status"
                aria-label="Carregando sugestões"
              >
                <div
                  *ngFor="let _ of quickQuestionPlaceholderSlots"
                  class="chatbot__quickChip chatbot__quickChip--loading"
                  aria-hidden="true"
                >
                  <p class="placeholder-glow mb-0 w-100">
                    <span class="placeholder col-12 chatbot__quickPlaceholderLine"></span>
                  </p>
                </div>
              </div>

              <div
                *ngIf="!quickQuestionsLoading"
                class="chatbot__quickGrid"
                role="list"
              >
                <button
                  *ngFor="let q of quickQuestions; let i = index"
                  class="chatbot__quickChip"
                  type="button"
                  role="listitem"
                  (click)="sendQuick(q)"
                >
                  <span class="chatbot__quickChipIcon" aria-hidden="true">
                    <span class="material-symbols-outlined">{{ quickQuestionIcon(i) }}</span>
                  </span>
                  <span class="chatbot__quickChipText">{{ q }}</span>
                  <span class="material-symbols-outlined chatbot__quickChipArrow" aria-hidden="true">
                    arrow_forward
                  </span>
                </button>
              </div>
            </div>
          </div>

          <ng-container
            *ngFor="let m of messages; trackBy: trackByMessageId"
          >
          <div
            class="chatbot__msg"
            [class.is-user]="m.role === 'user'"
            [class.is-assistant]="m.role === 'assistant'"
          >
            <div class="chatbot__msgStack">
            <div
              *ngIf="m.role === 'assistant' && shouldShowThinkingDock(m)"
              class="chatbot__thinkingDock"
            >
              <app-chatbot-thinking-trace
                [activityLog]="thinkingActivityLog(m)"
                [currentActivity]="thinkingCurrentActivity(m)"
                [isActive]="isThinkingActiveForMessage(m)"
                [startedAt]="thinkingStartedAtForMessage(m)"
                [settledDurationSeconds]="thinkingSettledDuration(m)"
                [expandByDefault]="settings.expandProcessByDefault"
              ></app-chatbot-thinking-trace>
            </div>
            <div
              *ngIf="m.role === 'user' && m.files?.length"
              class="chatbot__reports chatbot__reports--user"
            >
              <ng-container *ngFor="let file of m.files">
                <ng-container
                  [ngTemplateOutlet]="chatFileCard"
                  [ngTemplateOutletContext]="{ $implicit: file }"
                ></ng-container>
              </ng-container>
            </div>

            <div
              class="chatbot__bubble"
              [class.chatbot__bubble--stream]="m.role === 'assistant'"
              *ngIf="shouldShowBubble(m)"
            >
              <div
                class="chatbot__bubbleText"
                *ngIf="hasBubbleText(m)"
                [class.is-streaming]="isStreamingMessage(m.id)"
                (click)="onBubbleLinkClick($event)"
                [innerHTML]="m.html"
              ></div>

              <div
                *ngIf="m.role === 'assistant' && (m.files?.length || isImageToolRunning(m))"
                class="chatbot__generatedFiles"
              >
                <figure
                  *ngIf="isImageToolRunning(m)"
                  class="chatbot__imageCard chatbot__imageCard--pending"
                  aria-busy="true"
                  aria-label="Gerando imagem"
                >
                  <div class="chatbot__imageCardSkeleton">
                    <span
                      class="material-symbols-outlined chatbot__imageCardSkeletonIcon"
                      aria-hidden="true"
                    >
                      image
                    </span>
                    <span class="chatbot__imageCardSkeletonLabel">{{ imageGenerationStatusLabel }}</span>
                  </div>
                </figure>
                <ng-container *ngFor="let file of m.files">
                  <figure
                    *ngIf="isChatImageFile(file); else chatDocFileCard"
                    class="chatbot__imageCard"
                    [class.chatbot__imageCard--pending]="isImagePreviewPending(m, file)"
                    [attr.aria-busy]="isImagePreviewPending(m, file) ? true : null"
                  >
                    <div
                      *ngIf="isImagePreviewPending(m, file)"
                      class="chatbot__imageCardSkeleton chatbot__imageCardSkeleton--overlay"
                    >
                      <span
                        class="material-symbols-outlined chatbot__imageCardSkeletonIcon"
                        aria-hidden="true"
                      >
                        image
                      </span>
                      <span class="chatbot__imageCardSkeletonLabel">{{
                        imagePreviewStatusLabel(m, file)
                      }}</span>
                      <button
                        *ngIf="isImagePreviewError(m, file)"
                        type="button"
                        class="chatbot__imageCardRetryBtn"
                        (click)="openChatFile(file)"
                      >
                        Abrir imagem
                      </button>
                    </div>
                    <img
                      #generatedImagePreview
                      class="chatbot__imageCardMedia"
                      [class.chatbot__imageCardMedia--hidden]="isImagePreviewPending(m, file)"
                      [attr.data-chat-image-preview]="imagePreviewAttrKey(m.id, file)"
                      [src]="chatFilePreviewUrl(file)"
                      [alt]="chatFileKindLabel(file)"
                      loading="eager"
                      fetchpriority="high"
                      decoding="async"
                      (load)="onGeneratedImagePreviewLoad(m.id, file, generatedImagePreview)"
                      (error)="onGeneratedImagePreviewError(m.id, file, generatedImagePreview)"
                    />
                    <figcaption
                      *ngIf="!isImagePreviewPending(m, file)"
                      class="chatbot__imageCardOverlay"
                    >
                      <span class="chatbot__imageCardLabel">{{ chatFileKindLabel(file) }}</span>
                      <div class="chatbot__imageCardActions">
                        <button
                          type="button"
                          class="chatbot__imageCardBtn"
                          (click)="openChatFile(file)"
                        >
                          <span class="material-symbols-outlined" aria-hidden="true">open_in_new</span>
                          Abrir
                        </button>
                        <button
                          type="button"
                          class="chatbot__imageCardBtn chatbot__imageCardBtn--primary"
                          (click)="downloadChatFile(file)"
                        >
                          <span class="material-symbols-outlined" aria-hidden="true">download</span>
                          Baixar
                        </button>
                      </div>
                    </figcaption>
                  </figure>
                  <ng-template #chatDocFileCard>
                    <ng-container
                      [ngTemplateOutlet]="chatFileCard"
                      [ngTemplateOutletContext]="{ $implicit: file }"
                    ></ng-container>
                  </ng-template>
                </ng-container>
              </div>

              <div
                *ngIf="m.role === 'assistant' && m.reports?.length"
                class="chatbot__reports"
              >
                <article
                  *ngFor="let report of m.reports"
                  class="chatbot__reportCard"
                  [class.is-ready]="report.status === 'ready'"
                  [class.is-error]="report.status === 'error'"
                >
                  <div class="chatbot__reportTop">
                    <button
                      type="button"
                      class="chatbot__reportHead"
                      (click)="openReportModal(report)"
                    >
                      <span
                        class="material-symbols-outlined chatbot__reportIcon"
                        aria-hidden="true"
                      >
                        {{
                          report.status === 'ready'
                            ? 'task'
                            : report.status === 'error'
                              ? 'error'
                              : 'progress_activity'
                        }}
                      </span>
                      <span class="chatbot__reportCopy">
                        <strong>{{ reportStatusLabel(report) }}</strong>
                        <span>{{ report.name }}</span>
                        <span class="chatbot__reportMeta">{{ reportCountLabel(report) }}</span>
                      </span>
                      <span
                        class="material-symbols-outlined chatbot__reportChevron"
                        aria-hidden="true"
                      >chevron_right</span>
                    </button>
                    <button
                      type="button"
                      class="chatbot__copyBtn"
                      [class.is-copied]="isCopied('report:' + report.id)"
                      [attr.aria-label]="isCopied('report:' + report.id) ? 'Dados copiados' : 'Copiar dados do relatório'"
                      [attr.title]="isCopied('report:' + report.id) ? 'Copiado' : 'Copiar dados'"
                      (click)="copyReport(report, $event)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">
                        {{ isCopied('report:' + report.id) ? 'check' : 'content_copy' }}
                      </span>
                    </button>
                  </div>

                  <div
                    *ngIf="report.appliedFilters?.length"
                    class="chatbot__reportFilters"
                  >
                    <span *ngFor="let filter of report.appliedFilters">
                      {{ filter.label }}: {{ filter.value }}
                    </span>
                  </div>

                  <div
                    *ngIf="report.status === 'ready'"
                    class="chatbot__reportDownloads"
                  >
                    <button
                      type="button"
                      class="chatbot__reportDownload"
                      [disabled]="!report.fileXLSX"
                      (click)="downloadReport(report.fileXLSX)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">download</span>
                      Baixar XLSX
                    </button>
                    <button
                      type="button"
                      class="chatbot__reportDownload chatbot__reportDownload--ghost"
                      [disabled]="!report.fileCSV"
                      (click)="downloadReport(report.fileCSV)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">download</span>
                      Baixar CSV
                    </button>
                  </div>
                </article>
              </div>

              <div
                *ngIf="m.role === 'assistant' && m.confirmations?.length"
                class="chatbot__approvalDock"
                role="group"
                [attr.aria-label]="'Confirmações pendentes'"
              >
                <article
                  *ngFor="let confirmation of primaryConfirmations(m.confirmations)"
                  class="chatbot__approvalCard"
                  [class.is-report]="isReportConfirmation(confirmation)"
                  [class.is-consumed]="confirmation.consumed"
                  [class.is-refused]="confirmation.consumed && confirmation.refused"
                >
                  <header class="chatbot__approvalHeader">
                    <span
                      *ngIf="!confirmation.consumed"
                      class="chatbot__approvalBadge"
                    >
                      <span class="chatbot__approvalBadgeDot" aria-hidden="true"></span>
                      <span
                        class="material-symbols-outlined"
                        aria-hidden="true"
                      >{{ confirmationIcon(confirmation) }}</span>
                      {{ confirmationBadgeLabel(confirmation) }}
                    </span>
                    <span
                      *ngIf="confirmation.consumed && confirmation.refused"
                      class="chatbot__approvalBadge chatbot__approvalBadge--refused"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">cancel</span>
                      Ação recusada
                    </span>
                    <span
                      *ngIf="confirmation.consumed && !confirmation.refused"
                      class="chatbot__approvalBadge chatbot__approvalBadge--done"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">check_circle</span>
                      Ação confirmada
                    </span>
                    <button
                      type="button"
                      class="chatbot__copyBtn"
                      [class.is-copied]="isCopied('confirm:' + confirmation.id)"
                      [attr.aria-label]="isCopied('confirm:' + confirmation.id) ? 'Dados copiados' : 'Copiar dados da confirmação'"
                      [attr.title]="isCopied('confirm:' + confirmation.id) ? 'Copiado' : 'Copiar dados'"
                      (click)="copyConfirmation(confirmation, $event)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">
                        {{ isCopied('confirm:' + confirmation.id) ? 'check' : 'content_copy' }}
                      </span>
                    </button>
                  </header>

                  <div class="chatbot__approvalBody">
                    <h3 class="chatbot__approvalTitle">{{ confirmation.title }}</h3>

                    <p
                      *ngIf="!confirmation.consumed"
                      class="chatbot__approvalSummary"
                    >{{ confirmation.summary }}</p>

                    <p
                      *ngIf="confirmation.agentName && !confirmation.consumed"
                      class="chatbot__approvalAgent"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">smart_toy</span>
                      Solicitado por {{ confirmation.agentName }}
                    </p>

                    <dl
                      *ngIf="!confirmation.consumed && confirmation.details?.length"
                      class="chatbot__approvalPreview"
                    >
                      <div
                        class="chatbot__approvalPreviewRow"
                        *ngFor="let detail of confirmationPreviewDetails(confirmation)"
                      >
                        <dt>{{ detail.label }}</dt>
                        <dd>{{ detail.value }}</dd>
                      </div>
                    </dl>

                    <p
                      *ngIf="!confirmation.consumed && confirmationHasMoreDetails(confirmation)"
                      class="chatbot__approvalMore"
                    >
                      +{{ confirmationExtraDetailsCount(confirmation) }}
                      {{ confirmationExtraDetailsCount(confirmation) === 1 ? 'detalhe' : 'detalhes' }}
                      no painel de revisão
                    </p>
                  </div>

                  <footer
                    *ngIf="!confirmation.consumed"
                    class="chatbot__approvalFooter"
                  >
                    <button
                      type="button"
                      class="chatbot__approvalRefuseBtn"
                      [disabled]="isTyping"
                      (click)="refuseConfirmationInline(confirmation, $event)"
                    >
                      Recusar
                    </button>
                    <button
                      type="button"
                      class="chatbot__approvalReviewBtn"
                      [disabled]="isTyping"
                      (click)="openConfirmationModal(confirmation)"
                    >
                      Revisar e confirmar
                      <span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
                    </button>
                  </footer>
                </article>
              </div>
            </div>

              <footer
                *ngIf="m.role === 'assistant' && showStreamFoot(m)"
                class="chatbot__streamFoot"
              >
                <div class="chatbot__streamToolbar">
                  <div class="chatbot__streamActions" role="toolbar" aria-label="Ações da resposta">
                    <button
                      type="button"
                      class="chatbot__streamBtn"
                      [class.is-copied]="isCopied('msg:' + m.id)"
                      [attr.aria-label]="isCopied('msg:' + m.id) ? 'Mensagem copiada' : 'Copiar mensagem'"
                      [attr.title]="isCopied('msg:' + m.id) ? 'Copiado' : 'Copiar'"
                      (click)="copyMessage(m, $event)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">
                        {{ isCopied('msg:' + m.id) ? 'check' : 'content_copy' }}
                      </span>
                    </button>
                    <button
                      *ngIf="canRegenerate(m)"
                      type="button"
                      class="chatbot__streamBtn"
                      aria-label="Regenerar resposta"
                      title="Regenerar"
                      (click)="regenerateMessage(m, $event)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">replay</span>
                    </button>
                    <button
                      *ngIf="ttsSupported"
                      type="button"
                      class="chatbot__streamBtn"
                      [class.is-active]="isSpeakingMessage(m.id)"
                      [attr.aria-label]="isSpeakingMessage(m.id) ? 'Parar áudio' : 'Ouvir resposta'"
                      [attr.title]="isSpeakingMessage(m.id) ? 'Parar áudio' : 'Ouvir'"
                      (click)="speakMessage(m, $event)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">
                        {{ isSpeakingMessage(m.id) ? 'stop' : 'volume_up' }}
                      </span>
                    </button>
                    <div
                      *ngIf="hasRevisionHistory(m)"
                      class="chatbot__revisionNav chatbot__revisionNav--stream"
                    >
                      <button
                        type="button"
                        class="chatbot__streamBtn"
                        aria-label="Versão anterior"
                        title="Versão anterior"
                        (click)="cycleRevision(m, -1, $event)"
                      >
                        <span class="material-symbols-outlined" aria-hidden="true">chevron_left</span>
                      </button>
                      <span class="chatbot__revisionLabel">{{ revisionLabel(m) }}</span>
                      <button
                        type="button"
                        class="chatbot__streamBtn"
                        aria-label="Próxima versão"
                        title="Próxima versão"
                        (click)="cycleRevision(m, 1, $event)"
                      >
                        <span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
                      </button>
                    </div>
                    <button
                      *ngIf="canEditMessage(m)"
                      type="button"
                      class="chatbot__streamBtn"
                      [class.is-active]="editingMessageId === m.id"
                      aria-label="Editar mensagem"
                      title="Editar"
                      (click)="startEditMessage(m, $event)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">edit</span>
                    </button>
                    <button
                      *ngIf="canBranchFrom(m)"
                      type="button"
                      class="chatbot__streamBtn"
                      aria-label="Ramificar daqui"
                      title="Ramificar"
                      (click)="branchFromMessage(m, $event)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">call_split</span>
                    </button>
                  </div>

                  <button
                    *ngIf="actionableSources(m.sources, m.actions).length as sourceCount"
                    type="button"
                    class="chatbot__sourcesBadge"
                    [class.is-open]="isSourcesPanelOpen(m.id)"
                    [attr.aria-expanded]="isSourcesPanelOpen(m.id)"
                    (click)="toggleSourcesPanel(m.id, $event)"
                  >
                    <span class="chatbot__sourceStack" aria-hidden="true">
                      <span
                        *ngFor="let source of sourcePreview(m.sources, m.actions); let i = index"
                        class="chatbot__sourceFaviconWrap"
                        [style.z-index]="10 - i"
                      >
                        <img
                          *ngIf="showSourceFavicon(source)"
                          class="chatbot__sourceFavicon"
                          [src]="sourceFaviconUrl(source)"
                          alt=""
                          width="16"
                          height="16"
                          loading="lazy"
                          decoding="async"
                          (error)="onSourceFaviconError(source)"
                        />
                        <span
                          *ngIf="!showSourceFavicon(source)"
                          class="chatbot__sourceDot"
                          [style.--dot-hue]="sourceDotHue(source, i)"
                        ></span>
                      </span>
                    </span>
                    <span class="chatbot__sourcesBadgeLabel">{{ sourcesCountLabel(sourceCount) }}</span>
                  </button>
                </div>

                <nav
                  *ngIf="isSourcesPanelOpen(m.id) && actionableSources(m.sources, m.actions).length"
                  class="chatbot__sourcesPanel"
                  aria-label="Fontes desta resposta"
                >
                  <ul class="chatbot__sourcesPanelList">
                    <li *ngFor="let source of actionableSources(m.sources, m.actions)">
                      <a
                        class="chatbot__sourcesPanelLink"
                        [href]="source.url"
                        [attr.target]="isExternalSource(source) ? '_blank' : null"
                        [attr.rel]="isExternalSource(source) ? 'noopener noreferrer' : null"
                        (click)="openSource(source, $event)"
                      >
                        <img
                          *ngIf="showSourceFavicon(source)"
                          class="chatbot__sourceFavicon chatbot__sourceFavicon--panel"
                          [src]="sourceFaviconUrl(source)"
                          alt=""
                          width="16"
                          height="16"
                          loading="lazy"
                          decoding="async"
                          (error)="onSourceFaviconError(source)"
                        />
                        <span
                          *ngIf="!showSourceFavicon(source)"
                          class="chatbot__sourceDot chatbot__sourceDot--panel"
                          [style.--dot-hue]="sourceDotHue(source, 0)"
                          aria-hidden="true"
                        ></span>
                        <span class="chatbot__sourcesPanelCopy">
                          <span class="chatbot__sourcesPanelTitle">{{ source.title }}</span>
                          <span
                            *ngIf="source.url"
                            class="chatbot__sourcesPanelHost"
                          >{{ sourceHostLabel(source.url) }}</span>
                        </span>
                        <span class="material-symbols-outlined" aria-hidden="true">arrow_outward</span>
                      </a>
                    </li>
                  </ul>
                </nav>

                <div
                  *ngIf="messageFollowUps(m).length"
                  class="chatbot__streamFollowUps"
                  role="group"
                  aria-label="Próximos passos sugeridos"
                >
                  <p class="chatbot__streamFollowUpsLabel">Próximos passos</p>
                  <button
                    *ngFor="let item of messageFollowUps(m)"
                    type="button"
                    class="chatbot__followRow"
                    (click)="sendFollowUp(item, $event)"
                  >
                    <span class="material-symbols-outlined" aria-hidden="true">subdirectory_arrow_left</span>
                    <span class="chatbot__followRowText">{{ item.label }}</span>
                  </button>
                </div>
              </footer>
            <div
              class="chatbot__msgMeta"
              *ngIf="m.role === 'user' && (settings.showTimestamps || hasBubbleText(m))"
            >
              <time
                *ngIf="settings.showTimestamps"
                class="chatbot__msgTime"
                [attr.datetime]="formatMessageIso(m.createdAt)"
              >{{ formatMessageTime(m.createdAt) }}</time>
              <button
                *ngIf="hasBubbleText(m)"
                type="button"
                class="chatbot__copyBtn"
                [class.is-copied]="isCopied('msg:' + m.id)"
                [attr.aria-label]="isCopied('msg:' + m.id) ? 'Mensagem copiada' : 'Copiar mensagem'"
                [attr.title]="isCopied('msg:' + m.id) ? 'Copiado' : 'Copiar mensagem'"
                (click)="copyMessage(m, $event)"
              >
                <span class="material-symbols-outlined" aria-hidden="true">
                  {{ isCopied('msg:' + m.id) ? 'check' : 'content_copy' }}
                </span>
              </button>
            </div>
            <div
              class="chatbot__msgMeta chatbot__msgMeta--assistant"
              *ngIf="m.role === 'assistant' && settings.showTimestamps && showStreamFoot(m)"
            >
              <time
                class="chatbot__msgTime"
                [attr.datetime]="formatMessageIso(m.createdAt)"
              >{{ formatMessageTime(m.createdAt) }}</time>
            </div>
            </div>
          </div>
          </ng-container>

          <ng-template #chatFileCard let-file>
            <article class="chatbot__reportCard is-ready">
              <button
                type="button"
                class="chatbot__reportHead"
                (click)="openFileModal(file)"
              >
                <span
                  class="material-symbols-outlined chatbot__reportIcon"
                  aria-hidden="true"
                >{{ chatFileIcon(file) }}</span>
                <span class="chatbot__reportCopy">
                  <strong>{{ chatFileKindLabel(file) }}</strong>
                  <span *ngIf="file.name !== chatFileKindLabel(file)">{{ file.name }}</span>
                  <span class="chatbot__reportMeta">{{ chatFileSizeLabel(file) }}</span>
                </span>
                <span
                  class="material-symbols-outlined chatbot__reportChevron"
                  aria-hidden="true"
                >chevron_right</span>
              </button>

              <div class="chatbot__reportDownloads">
                <button
                  type="button"
                  class="chatbot__reportDownload"
                  (click)="openChatFile(file)"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">open_in_new</span>
                  Abrir
                </button>
                <button
                  type="button"
                  class="chatbot__reportDownload chatbot__reportDownload--ghost"
                  (click)="downloadChatFile(file)"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">download</span>
                  Baixar
                </button>
              </div>
            </article>
          </ng-template>

          <div
            *ngIf="shouldShowPendingThinkingDock()"
            class="chatbot__msg is-assistant"
          >
            <div class="chatbot__msgStack">
              <div class="chatbot__thinkingDock">
                <app-chatbot-thinking-trace
                  [activityLog]="activityLog"
                  [currentActivity]="currentActivity"
                  [isActive]="isThinkingTraceActive"
                  [startedAt]="thinkingTraceStartedAt"
                  [expandByDefault]="settings.expandProcessByDefault"
                ></app-chatbot-thinking-trace>
              </div>
            </div>
          </div>
        </div>
        <button
          *ngIf="showScrollToLatest"
          type="button"
          class="chatbot__scrollLatest"
          aria-label="Ir para a mensagem mais recente"
          title="Ir para a mensagem mais recente"
          (click)="scrollMessagesToLatest()"
        >
          <span class="material-symbols-outlined" aria-hidden="true">arrow_downward</span>
        </button>
      </div>

        <div class="chatbot__composerDock">
          <div
            *ngIf="slashOpen"
            class="chatbot__slash"
            role="listbox"
            [attr.aria-label]="paletteAriaLabel"
            [attr.aria-activedescendant]="activeSlashOptionId"
          >
            <div class="chatbot__slashBody">
              <ng-container *ngIf="slashGroups.length; else slashEmpty">
                <section *ngFor="let group of slashGroups" class="chatbot__slashGroup">
                  <h3
                    *ngIf="showPaletteGroupTitles"
                    class="chatbot__slashGroupTitle"
                  >{{ group.group }}</h3>
                  <button
                    *ngFor="let item of group.items"
                    type="button"
                    class="chatbot__slashItem"
                    role="option"
                    [id]="'chatbot-slash-option-' + item.id"
                    [class.is-active]="activeSlashItemId === item.id"
                    [class.is-upload]="item.kind === 'upload'"
                    [class.is-command]="isComposerCommandItem(item)"
                    [class.is-agent]="item.kind === 'agent' && !isComposerCommandItem(item)"
                    [disabled]="isSlashItemDisabled(item)"
                    [attr.aria-selected]="activeSlashItemId === item.id"
                    [attr.aria-describedby]="'chatbot-slash-desc-' + item.id"
                    (mousedown)="$event.preventDefault()"
                    (mouseenter)="hoverSlashItem(item)"
                    (click)="applySlashSelection(item)"
                  >
                    <span class="chatbot__slashIcon" aria-hidden="true">
                      <span class="material-symbols-outlined">{{ item.icon }}</span>
                    </span>
                    <span class="chatbot__slashCopy">
                      <span class="chatbot__slashItemTitle">{{ paletteItemTitle(item) }}</span>
                      <span class="chatbot__slashSep" aria-hidden="true">—</span>
                      <span
                        class="chatbot__slashSubtitle"
                        [id]="'chatbot-slash-desc-' + item.id"
                      >{{ slashItemSubtitle(item) }}</span>
                    </span>
                  </button>
                </section>
              </ng-container>

              <ng-template #slashEmpty>
                <p class="chatbot__slashEmpty">{{ slashEmptyLabel }}</p>
              </ng-template>
            </div>

            <p class="chatbot__slashFoot">{{ paletteSearchHint }}</p>
          </div>

          <div
            *ngIf="queuedOutgoing.length"
            class="chatbot__queue"
            [class.is-hold]="isQueueHeld"
            aria-live="polite"
          >
            <div class="chatbot__queueHead">
              <span class="material-symbols-outlined" aria-hidden="true">
                {{ isQueueHeld ? 'front_hand' : 'schedule' }}
              </span>
              <span>{{ queueHoldLabel }}</span>
              <span class="chatbot__queueCount">{{ queuedOutgoing.length }}</span>
            </div>
            <ul class="chatbot__queueList">
              <li *ngFor="let item of queuedOutgoing" class="chatbot__queueItem">
                <span class="material-symbols-outlined" aria-hidden="true">
                  {{ item.attachments.length ? 'attach_file' : 'chat_bubble' }}
                </span>
                <span class="chatbot__queuePreview">{{ queuedPreview(item) }}</span>
                <button
                  type="button"
                  class="chatbot__queueRemove"
                  aria-label="Remover da fila"
                  (click)="removeQueuedOutgoing(item.id, $event)"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">close</span>
                </button>
              </li>
            </ul>
          </div>

          <div
            *ngIf="shareNotice"
            class="chatbot__notice"
            role="status"
          >
            <span class="material-symbols-outlined" aria-hidden="true">share</span>
            <p>{{ shareNotice }}</p>
          </div>

          <div
            *ngIf="readOnlyShare"
            class="chatbot__notice"
            role="status"
          >
            <span class="material-symbols-outlined" aria-hidden="true">visibility</span>
            <p>Conversa compartilhada em modo leitura. Você não vira dono deste histórico.</p>
          </div>

          <div
            *ngIf="editingMessageId"
            class="chatbot__notice chatbot__notice--edit"
            role="status"
          >
            <span class="material-symbols-outlined" aria-hidden="true">edit</span>
            <p>Editando a mensagem. Enviar trunca o que veio depois e gera de novo nesta conversa.</p>
            <button
              type="button"
              class="chatbot__voiceAlertClose"
              aria-label="Cancelar edição"
              (click)="cancelEditMessage()"
            >
              <span class="material-symbols-outlined" aria-hidden="true">close</span>
            </button>
          </div>

          <div
            *ngIf="voiceError"
            class="chatbot__voiceAlert"
            role="alert"
          >
            <span class="material-symbols-outlined" aria-hidden="true">mic_off</span>
            <p>{{ voiceError }}</p>
            <button
              type="button"
              class="chatbot__voiceAlertClose"
              aria-label="Fechar aviso do microfone"
              (click)="dismissVoiceError()"
            >
              <span class="material-symbols-outlined" aria-hidden="true">close</span>
            </button>
          </div>

          <form
            class="chatbot__composer"
            (ngSubmit)="send()"
            (dragover)="onComposerDragOver($event)"
            (dragleave)="onComposerDragLeave($event)"
            (drop)="onComposerDrop($event)"
            [class.is-drop]="isComposerDragOver"
            [class.is-compact]="isComposerCompact"
            [class.is-recording]="isVoiceRecording || isVoiceStarting"
            [class.is-transcribing]="isVoiceTranscribing"
          >
            <input
              #fileInput
              type="file"
              hidden
              multiple
              [accept]="chatAttachmentAccept"
              (change)="onFilesSelected($event)"
            />
            <div *ngIf="isVoiceBusy" class="chatbot__voiceStage">
              <button
                *ngIf="!isVoiceTranscribing"
                class="chatbot__voiceCancel"
                type="button"
                aria-label="Cancelar gravação"
                title="Cancelar"
                (click)="cancelVoice()"
              >
                <span class="material-symbols-outlined" aria-hidden="true">close</span>
              </button>

              <div class="chatbot__voiceMeter" aria-live="polite">
                <span
                  class="chatbot__voiceBars"
                  [class.is-live]="isVoiceRecording"
                  aria-hidden="true"
                >
                  <i
                    *ngFor="let level of voiceLevels; trackBy: trackVoiceBar"
                    [style.transform]="'scaleY(' + level + ')'"
                  ></i>
                </span>
                <span class="chatbot__voiceCopy">
                  <span class="chatbot__voiceDot" *ngIf="isVoiceRecording"></span>
                  {{ voiceStageLabel }}
                </span>
              </div>

              <button
                *ngIf="isVoiceRecording || isVoiceStarting"
                class="chatbot__voiceStop"
                type="button"
                [disabled]="isVoiceStarting"
                aria-label="Parar e transcrever"
                title="Parar e transcrever"
                (click)="toggleVoiceCapture()"
              >
                <span class="material-symbols-outlined" aria-hidden="true">check</span>
              </button>
            </div>

            <div *ngIf="!isVoiceBusy" class="chatbot__inputWrap">
              <div
                *ngIf="pendingUploads.length"
                class="chatbot__pendingFiles"
              >
                <article
                  *ngFor="let item of pendingUploads"
                  class="chatbot__pendingFile"
                  [class.is-error]="item.status === 'error'"
                  [class.is-ready]="item.status === 'ready'"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">
                    {{
                      item.status === 'ready'
                        ? 'draft'
                        : item.status === 'error'
                          ? 'error'
                          : 'progress_activity'
                    }}
                  </span>
                  <span class="chatbot__pendingFileCopy">
                    <strong>{{ item.fileName }}</strong>
                    <span>{{ pendingUploadLabel(item) }}</span>
                  </span>
                  <button
                    type="button"
                    class="chatbot__pendingFileRemove"
                    aria-label="Remover anexo"
                    (click)="removePendingUpload(item.id)"
                  >
                    <span class="material-symbols-outlined" aria-hidden="true">close</span>
                  </button>
                </article>
              </div>
              <div class="chatbot__inputShell">
                <div class="chatbot__composerTools">
                  <button
                    *ngIf="!readOnlyShare"
                    class="chatbot__attach"
                    type="button"
                    [class.is-open]="slashOpen && slashSource === 'plus'"
                    aria-label="Adicionar ao chat"
                    title="Adicionar arquivos ou agentes"
                    (click)="togglePlusMenu()"
                  >
                    <span class="material-symbols-outlined" aria-hidden="true">add</span>
                  </button>
                </div>
                <div class="chatbot__composerField">
                  <div
                    class="chatbot__highlight"
                    [innerHTML]="draftHighlightHtml"
                    aria-hidden="true"
                  ></div>
                  <textarea
                    #messageInput
                    class="chatbot__input"
                    name="draft"
                    rows="1"
                    [(ngModel)]="draft"
                    (input)="onDraftInput($event)"
                    (scroll)="onComposerScroll($event)"
                    (click)="onDraftSelect($event)"
                    (keyup)="onDraftSelect($event)"
                    (keydown)="onInputKeydown($event)"
                    (paste)="onComposerPaste($event)"
                    autocomplete="off"
                    [placeholder]="composerPlaceholder"
                    [disabled]="readOnlyShare"
                  ></textarea>
                </div>
              </div>
            </div>

            <div *ngIf="!isVoiceBusy" class="chatbot__composerActions">
              <div
                *ngIf="canUseAgentCommands"
                id="chatbot-model-picker"
                class="chatbot__modelPicker"
              >
                <button
                  class="chatbot__modelTrigger"
                  type="button"
                  [class.is-open]="modelPickerOpen"
                  [disabled]="readOnlyShare"
                  [attr.aria-expanded]="modelPickerOpen"
                  aria-haspopup="listbox"
                  aria-controls="chatbot-model-menu"
                  [attr.aria-label]="'Modo de IA: ' + selectedChatModel.hint"
                  [title]="selectedChatModel.hint"
                  (click)="toggleModelPicker($event)"
                >
                  <span class="chatbot__modelTriggerLabel">{{ selectedChatModel.hint }}</span>
                  <span class="material-symbols-outlined chatbot__modelTriggerChevron" aria-hidden="true">
                    expand_more
                  </span>
                </button>
                <div
                  *ngIf="modelPickerOpen"
                  id="chatbot-model-menu"
                  class="chatbot__modelMenu"
                  role="listbox"
                  [attr.aria-label]="'Modos de IA'"
                >
                  <button
                    *ngFor="let option of chatModelOptions"
                    class="chatbot__modelOption"
                    type="button"
                    role="option"
                    [class.is-active]="option.id === selectedChatModel.id"
                    [attr.aria-selected]="option.id === selectedChatModel.id"
                    [attr.aria-label]="option.hint"
                    (click)="selectChatModel(option.id, $event)"
                  >
                    <span class="chatbot__modelOptionCopy">
                      <span class="chatbot__modelOptionName">{{ option.hint }}</span>
                    </span>
                    <span
                      *ngIf="option.id === selectedChatModel.id"
                      class="material-symbols-outlined chatbot__modelOptionCheck"
                      aria-hidden="true"
                    >check</span>
                  </button>
                </div>
              </div>
              <button
                class="chatbot__mic"
                type="button"
                [class.is-unsupported]="!voiceSupported"
                [disabled]="isUploadingAttachments || readOnlyShare"
                [attr.aria-label]="voiceSupported ? 'Falar em português do Brasil' : 'Fala indisponível neste navegador'"
                [title]="voiceSupported ? 'Falar em português do Brasil' : 'Fala indisponível neste navegador'"
                (click)="toggleVoiceCapture()"
              >
                <span class="material-symbols-outlined" aria-hidden="true">mic</span>
              </button>

              <button
                *ngIf="!canStopGeneration"
                class="chatbot__send"
                type="submit"
                [disabled]="!canSend || readOnlyShare"
                aria-label="Enviar mensagem"
              >
                <span class="material-symbols-outlined" aria-hidden="true">send</span>
              </button>
              <button
                *ngIf="canStopGeneration"
                class="chatbot__send chatbot__send--stop"
                type="button"
                aria-label="Parar geração"
                title="Parar geração"
                (click)="stopGeneration($event)"
              >
                <span class="material-symbols-outlined" aria-hidden="true">stop</span>
              </button>
            </div>
          </form>
        </div>

        <div *ngIf="settings.showKeyboardHints" class="chatbot__hint">
          <ng-container *ngIf="settings.enterToSend; else enterNewlineHint">
            <kbd>Enter</kbd> envia
          </ng-container>
          <ng-template #enterNewlineHint>
            <kbd>Ctrl</kbd> <kbd>Enter</kbd> envia · <kbd>Enter</kbd> quebra linha
          </ng-template>
          <span *ngIf="canUseAgentCommands"> · <kbd>↑</kbd> <kbd>↓</kbd> paleta · <kbd>+</kbd> <kbd>/</kbd> ou <kbd>&#64;</kbd> agentes</span>
          · clipe para anexar · microfone em português · clique fora ou <kbd>Esc</kbd> fecha
          <span *ngIf="canUseAgentCommands"> · <kbd>{{ chatOpenShortcutLabel }}</kbd> abre · <kbd>Ctrl</kbd><kbd>J</kbd> alterna · <kbd>Ctrl</kbd><kbd>K</kbd> foca</span>
          <span *ngIf="!isExpanded && !isMobile"> · expandir no menu · arraste pelo título · redimensione pelas bordas</span>
        </div>
      </div>

      <div
        *ngIf="settingsOpen && canUseAgentCommands"
        class="chatbot__settings"
        role="dialog"
        aria-modal="true"
        aria-labelledby="chatbot-settings-title"
      >
        <header class="chatbot__settingsHeader">
          <button
            type="button"
            class="chatbot__iconBtn chatbot__iconBtn--neutral"
            (click)="closeSettings($event)"
            aria-label="Voltar ao chat"
          >
            <span class="material-symbols-outlined" aria-hidden="true">arrow_back</span>
          </button>
          <div class="chatbot__settingsHeading">
            <h2 id="chatbot-settings-title" class="chatbot__settingsTitle">Configurações</h2>
            <p class="chatbot__settingsSubtitle">Preferências deste navegador</p>
          </div>
        </header>

        <div class="chatbot__settingsBody">
          <section class="chatbot__settingsGroup" aria-labelledby="chatbot-settings-style">
            <h3 id="chatbot-settings-style" class="chatbot__settingsGroupTitle">Resposta da IA</h3>

            <div class="chatbot__settingBlock">
              <div class="chatbot__settingCopy">
                <strong>Como o assistente escreve</strong>
                <span>Vale nas próximas mensagens deste navegador</span>
              </div>
              <div class="chatbot__styleList" role="radiogroup" aria-label="Modo de resposta da IA">
                <button
                  *ngFor="let option of responseStyleOptions"
                  type="button"
                  class="chatbot__styleCard"
                  role="radio"
                  [attr.name]="'chatbot-response-style'"
                  [class.is-active]="settings.responseStyle === option.id"
                  [attr.aria-checked]="settings.responseStyle === option.id"
                  (click)="setResponseStyle(option.id, $event)"
                >
                  <span class="material-symbols-outlined chatbot__styleIcon" aria-hidden="true">{{ option.icon }}</span>
                  <span class="chatbot__styleCopy">
                    <strong>
                      {{ option.label }}
                      <span *ngIf="option.isDefault" class="chatbot__styleBadge">Padrão</span>
                    </strong>
                    <span class="chatbot__styleHint">{{ option.description }}</span>
                  </span>
                </button>
              </div>
            </div>
          </section>

          <section class="chatbot__settingsGroup" aria-labelledby="chatbot-settings-look">
            <h3 id="chatbot-settings-look" class="chatbot__settingsGroupTitle">Aparência</h3>

            <div class="chatbot__settingBlock">
              <div class="chatbot__settingCopy">
                <strong>Tamanho da fonte</strong>
                <span>Ajusta bolhas, composer e texto de boas-vindas</span>
              </div>
              <div class="chatbot__fontScale" role="group" aria-label="Tamanho da fonte do chat">
                <button
                  *ngFor="let option of fontSizeOptions"
                  type="button"
                  class="chatbot__fontScaleBtn"
                  [class.is-active]="settings.fontSize === option.id"
                  [attr.aria-pressed]="settings.fontSize === option.id"
                  (click)="setFontSize(option.id, $event)"
                >
                  <span
                    class="chatbot__fontScaleSample"
                    [attr.data-size]="option.id"
                  >{{ option.sample }}</span>
                  {{ option.label }}
                </button>
              </div>
            </div>

            <div class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Densidade compacta</strong>
                <span>Menos espaço entre mensagens e chips</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.compactDensity"
                [class.is-on]="settings.compactDensity"
                (click)="toggleSetting('compactDensity')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>

            <div class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Data e horário nas mensagens</strong>
                <span>Mostra o dia e a hora embaixo de cada bolha</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.showTimestamps"
                [class.is-on]="settings.showTimestamps"
                (click)="toggleSetting('showTimestamps')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>
          </section>

          <section class="chatbot__settingsGroup" aria-labelledby="chatbot-settings-behavior">
            <h3 id="chatbot-settings-behavior" class="chatbot__settingsGroupTitle">Comportamento</h3>

            <div class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Nova conversa ao clicar no ícone</strong>
                <span>FAB e tab Inteligência Wosi começam um fio vazio. Desligue para retomar a conversa anterior</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.openNewConversationOnLaunch"
                [class.is-on]="settings.openNewConversationOnLaunch"
                (click)="toggleSetting('openNewConversationOnLaunch')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>

            <div class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Abrir com lista de conversas</strong>
                <span>Já entra com o menu de histórico visível</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.openWithSidebar"
                [class.is-on]="settings.openWithSidebar"
                (click)="toggleSetting('openWithSidebar')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>

            <div class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Manter lista ao trocar de conversa</strong>
                <span>Não fecha o histórico quando você seleciona um chat</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.keepSidebarOnSelect"
                [class.is-on]="settings.keepSidebarOnSelect"
                (click)="toggleSetting('keepSidebarOnSelect')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>

            <div class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Enter envia a mensagem</strong>
                <span>Desligue para que Enter quebre linha e Ctrl+Enter envie</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.enterToSend"
                [class.is-on]="settings.enterToSend"
                (click)="toggleSetting('enterToSend')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>

            <div class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Expandir rastro da IA</strong>
                <span>Abre automaticamente as ferramentas usadas na resposta</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.expandProcessByDefault"
                [class.is-on]="settings.expandProcessByDefault"
                (click)="toggleSetting('expandProcessByDefault')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>

            <div class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Atalhos de teclado</strong>
                <span>
                  Exibe a dica de Enter/Esc embaixo do composer
                  <ng-container *ngIf="canUseAgentCommands">
                    · <kbd>{{ chatOpenShortcutLabel }}</kbd> abre o painel · <kbd>Ctrl</kbd><kbd>J</kbd> alterna · <kbd>Ctrl</kbd><kbd>K</kbd> foca o composer
                  </ng-container>
                </span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.showKeyboardHints"
                [class.is-on]="settings.showKeyboardHints"
                (click)="toggleSetting('showKeyboardHints')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>

            <div *ngIf="ttsSupported" class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Ler respostas em voz alta</strong>
                <span>Usa a voz do navegador em português (pt-BR), sem custo de API</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.ttsEnabled"
                [class.is-on]="settings.ttsEnabled"
                (click)="toggleSetting('ttsEnabled')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>

            <div *ngIf="ttsSupported" class="chatbot__settingRow">
              <div class="chatbot__settingCopy">
                <strong>Loop de voz</strong>
                <span>Depois da resposta, grava o microfone e envia a transcrição automaticamente</span>
              </div>
              <button
                type="button"
                class="chatbot__switch"
                role="switch"
                [attr.aria-checked]="settings.voiceLoopEnabled"
                [class.is-on]="settings.voiceLoopEnabled"
                (click)="toggleSetting('voiceLoopEnabled')"
              >
                <span class="chatbot__switchThumb"></span>
              </button>
            </div>
          </section>

          <section
            *ngIf="isLoggedIn"
            class="chatbot__settingsGroup"
            aria-labelledby="chatbot-settings-memory"
          >
            <h3 id="chatbot-settings-memory" class="chatbot__settingsGroupTitle">Memória</h3>
            <p class="chatbot__memoryIntro">
              Fatos que o assistente lembra desta conta. Tools do chat também gravam aqui.
            </p>
            <p *ngIf="memoriesLoading" class="chatbot__memoryEmpty">Carregando memória…</p>
            <p *ngIf="!memoriesLoading && !memories.length" class="chatbot__memoryEmpty">
              Nenhum fato salvo ainda.
            </p>
            <p *ngIf="memoryNotice" class="chatbot__memoryNotice" role="status">{{ memoryNotice }}</p>
            <article
              *ngFor="let item of memories"
              class="chatbot__memoryCard"
            >
              <span class="chatbot__memoryMeta">{{ item.category || 'fato' }}</span>
              <textarea
                class="chatbot__memoryInput"
                rows="3"
                [ngModel]="memoryDrafts[item.id]"
                (ngModelChange)="memoryDrafts[item.id] = $event"
                [attr.aria-label]="'Editar memória ' + (item.category || item.id)"
              ></textarea>
              <div class="chatbot__memoryActions">
                <button
                  type="button"
                  class="chatbot__memorySave"
                  [disabled]="memoryBusyId === item.id"
                  (click)="saveMemory(item)"
                >
                  Salvar
                </button>
                <button
                  type="button"
                  class="chatbot__memoryForget"
                  [disabled]="memoryBusyId === item.id"
                  (click)="forgetMemory(item)"
                >
                  Esquecer
                </button>
              </div>
            </article>
            <button
              *ngIf="memories.length"
              type="button"
              class="chatbot__memoryForgetAll"
              [disabled]="memoryBusyId === 'all'"
              (click)="forgetAllMemories()"
            >
              Esquecer tudo
            </button>
          </section>
        </div>

        <footer class="chatbot__settingsFooter">
          <button
            type="button"
            class="chatbot__settingsReset"
            (click)="resetSettings($event)"
          >
            Restaurar padrão
          </button>
        </footer>
      </div>
    </div>

    <ng-container *ngIf="!isMobile && !isExpanded">
      <span
        class="chatbot__resize chatbot__resize--n"
        (pointerdown)="onResizeHandlePointerDown('n', $event)"
        (pointermove)="onResizeHandlePointerMove($event)"
        (pointerup)="onResizeHandlePointerUp($event)"
        (pointercancel)="onResizeHandlePointerUp($event)"
      ></span>
      <span
        class="chatbot__resize chatbot__resize--s"
        (pointerdown)="onResizeHandlePointerDown('s', $event)"
        (pointermove)="onResizeHandlePointerMove($event)"
        (pointerup)="onResizeHandlePointerUp($event)"
        (pointercancel)="onResizeHandlePointerUp($event)"
      ></span>
      <span
        class="chatbot__resize chatbot__resize--e"
        (pointerdown)="onResizeHandlePointerDown('e', $event)"
        (pointermove)="onResizeHandlePointerMove($event)"
        (pointerup)="onResizeHandlePointerUp($event)"
        (pointercancel)="onResizeHandlePointerUp($event)"
      ></span>
      <span
        class="chatbot__resize chatbot__resize--w"
        (pointerdown)="onResizeHandlePointerDown('w', $event)"
        (pointermove)="onResizeHandlePointerMove($event)"
        (pointerup)="onResizeHandlePointerUp($event)"
        (pointercancel)="onResizeHandlePointerUp($event)"
      ></span>
      <span
        class="chatbot__resize chatbot__resize--ne"
        (pointerdown)="onResizeHandlePointerDown('ne', $event)"
        (pointermove)="onResizeHandlePointerMove($event)"
        (pointerup)="onResizeHandlePointerUp($event)"
        (pointercancel)="onResizeHandlePointerUp($event)"
      ></span>
      <span
        class="chatbot__resize chatbot__resize--nw"
        (pointerdown)="onResizeHandlePointerDown('nw', $event)"
        (pointermove)="onResizeHandlePointerMove($event)"
        (pointerup)="onResizeHandlePointerUp($event)"
        (pointercancel)="onResizeHandlePointerUp($event)"
      ></span>
      <span
        class="chatbot__resize chatbot__resize--se"
        (pointerdown)="onResizeHandlePointerDown('se', $event)"
        (pointermove)="onResizeHandlePointerMove($event)"
        (pointerup)="onResizeHandlePointerUp($event)"
        (pointercancel)="onResizeHandlePointerUp($event)"
      ></span>
      <span
        class="chatbot__resize chatbot__resize--sw"
        (pointerdown)="onResizeHandlePointerDown('sw', $event)"
        (pointermove)="onResizeHandlePointerMove($event)"
        (pointerup)="onResizeHandlePointerUp($event)"
        (pointercancel)="onResizeHandlePointerUp($event)"
      ></span>
    </ng-container>
  </section>

  <div
    *ngIf="pendingConfirmation"
    class="chatbot__confirmBackdrop"
    role="presentation"
    (click)="closeConfirmationModal()"
  ></div>

  <div
    *ngIf="pendingConfirmation"
    class="chatbot__confirmModal"
    role="dialog"
    aria-modal="true"
    [class.is-report]="isReportConfirmation(pendingConfirmation)"
    [attr.aria-labelledby]="'chatbot-confirm-title'"
  >
    <header class="chatbot__confirmHeader">
      <div class="chatbot__confirmTitleWrap">
        <span
          class="material-symbols-outlined chatbot__confirmIcon"
          aria-hidden="true"
        >{{ confirmationIcon(pendingConfirmation) }}</span>
        <div class="chatbot__confirmTitleStack">
          <p class="chatbot__confirmEyebrow">
            {{ confirmationBadgeLabel(pendingConfirmation) }}
          </p>
          <h2 id="chatbot-confirm-title" class="chatbot__confirmTitle">
            {{ pendingConfirmation.title }}
          </h2>
        </div>
      </div>
      <button
        type="button"
        class="chatbot__iconBtn chatbot__iconBtn--neutral"
        (click)="closeConfirmationModal()"
        aria-label="Fechar confirmação"
      >
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="chatbot__confirmBody">
      <p
        *ngIf="pendingConfirmation.agentName"
        class="chatbot__confirmAgent"
      >
        <span class="material-symbols-outlined" aria-hidden="true">smart_toy</span>
        Solicitado por {{ pendingConfirmation.agentName }}
      </p>

      <p class="chatbot__confirmLead">{{ pendingConfirmation.summary }}</p>

      <dl class="chatbot__confirmDetails" *ngIf="pendingConfirmation.details.length">
        <div
          class="chatbot__confirmDetailRow"
          *ngFor="let detail of pendingConfirmation.details"
        >
          <dt>{{ detail.label }}</dt>
          <dd>{{ detail.value }}</dd>
        </div>
      </dl>

      <aside class="chatbot__confirmCallout" role="note">
        <span class="material-symbols-outlined" aria-hidden="true">info</span>
        <p>
          <strong>Confirme apenas se os dados estão corretos.</strong>
          A ação será executada em seu nome e registrada na auditoria.
          Recusar ou cancelar não altera nada no sistema.
        </p>
      </aside>
    </div>

    <footer class="chatbot__confirmFooter">
      <button
        type="button"
        class="chatbot__confirmRefuseBtn"
        (click)="refusePendingAction()"
        [disabled]="isTyping"
      >
        Recusar
      </button>
      <button
        type="button"
        class="chatbot__confirmCancelBtn"
        (click)="closeConfirmationModal()"
        [disabled]="isTyping"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="chatbot__confirmSubmitBtn"
        (click)="confirmPendingAction()"
        [disabled]="isTyping"
      >
        {{ confirmationSubmitLabel(pendingConfirmation) }}
      </button>
    </footer>
  </div>

  <div
    *ngIf="pendingReport"
    class="chatbot__confirmBackdrop"
    role="presentation"
    (click)="closeReportModal()"
  ></div>

  <div
    *ngIf="pendingReport"
    class="chatbot__confirmModal chatbot__reportModal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="chatbot-report-title"
  >
    <header class="chatbot__confirmHeader">
      <div class="chatbot__confirmTitleWrap">
        <span
          class="material-symbols-outlined chatbot__confirmIcon"
          [class.is-spin]="pendingReport.status === 'processing'"
          aria-hidden="true"
        >
          {{
            pendingReport.status === 'ready'
              ? 'task'
              : pendingReport.status === 'error'
                ? 'error'
                : 'progress_activity'
          }}
        </span>
        <h2 id="chatbot-report-title" class="chatbot__confirmTitle">
          {{ reportStatusLabel(pendingReport) }}
        </h2>
      </div>
      <button
        type="button"
        class="chatbot__iconBtn chatbot__iconBtn--neutral"
        (click)="closeReportModal()"
        aria-label="Fechar relatório"
      >
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="chatbot__confirmBody">
      <p class="chatbot__confirmSummary">{{ pendingReport.name }}</p>
      <p class="chatbot__reportCount">{{ reportCountLabel(pendingReport) }}</p>

      <div
        *ngIf="pendingReport.status === 'processing'"
        class="chatbot__reportProgress"
        aria-hidden="true"
      >
        <span></span>
      </div>

      <p
        *ngIf="pendingReport.status === 'processing'"
        class="chatbot__confirmNote"
      >
        Estamos montando a planilha com os filtros combinados. Isso costuma levar alguns segundos — você pode fechar este painel que o card na conversa continua acompanhando.
      </p>

      <p
        *ngIf="pendingReport.status === 'error'"
        class="chatbot__confirmNote"
      >
        Não conseguimos concluir a extração. Tente de novo em instantes ou gere o relatório pela listagem.
      </p>

      <dl
        class="chatbot__confirmDetails"
        *ngIf="pendingReport.appliedFilters?.length"
      >
        <div
          class="chatbot__confirmDetailRow"
          *ngFor="let filter of pendingReport.appliedFilters"
        >
          <dt>{{ filter.label }}</dt>
          <dd>{{ filter.value }}</dd>
        </div>
      </dl>
    </div>

    <footer class="chatbot__confirmFooter">
      <button
        type="button"
        class="chatbot__confirmCancelBtn"
        (click)="closeReportModal()"
      >
        Fechar
      </button>
      <ng-container *ngIf="pendingReport.status === 'ready'">
        <button
          type="button"
          class="chatbot__confirmSubmitBtn"
          [disabled]="!pendingReport.fileXLSX"
          (click)="downloadReport(pendingReport.fileXLSX)"
        >
          Baixar XLSX
        </button>
        <button
          type="button"
          class="chatbot__reportDownload chatbot__reportDownload--ghost"
          [disabled]="!pendingReport.fileCSV"
          (click)="downloadReport(pendingReport.fileCSV)"
        >
          Baixar CSV
        </button>
      </ng-container>
    </footer>
  </div>

  <div
    *ngIf="pendingChatFile"
    class="chatbot__confirmBackdrop"
    role="presentation"
    (click)="closeFileModal()"
  ></div>

  <div
    *ngIf="pendingChatFile"
    class="chatbot__confirmModal chatbot__reportModal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="chatbot-file-title"
  >
    <header class="chatbot__confirmHeader">
      <div class="chatbot__confirmTitleWrap">
        <span
          class="material-symbols-outlined chatbot__confirmIcon"
          aria-hidden="true"
        >{{ chatFileIcon(pendingChatFile) }}</span>
        <h2 id="chatbot-file-title" class="chatbot__confirmTitle">
          {{ chatFileKindLabel(pendingChatFile) }}
        </h2>
      </div>
      <button
        type="button"
        class="chatbot__iconBtn chatbot__iconBtn--neutral"
        (click)="closeFileModal()"
        aria-label="Fechar arquivo"
      >
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="chatbot__confirmBody">
      <p class="chatbot__confirmSummary">{{ pendingChatFile.name }}</p>
      <p class="chatbot__reportCount">{{ chatFileSizeLabel(pendingChatFile) }}</p>
      <p class="chatbot__confirmNote">
        Abra em uma nova aba para visualizar ou baixe o arquivo.
      </p>
    </div>

    <footer class="chatbot__confirmFooter">
      <button
        type="button"
        class="chatbot__confirmCancelBtn"
        (click)="closeFileModal()"
      >
        Fechar
      </button>
      <button
        type="button"
        class="chatbot__confirmSubmitBtn"
        (click)="openChatFile(pendingChatFile)"
      >
        Abrir
      </button>
      <button
        type="button"
        class="chatbot__reportDownload chatbot__reportDownload--ghost"
        (click)="downloadChatFile(pendingChatFile)"
      >
        Baixar
      </button>
    </footer>
  </div>
</div>
